import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取当前登录用户所属供应商以及下属供应商
 * @param data
 *
 */
export const getMerchantList = () => {
  return request({
    url: env.ferryUrl + '/merchant/getMerchantList',
    method: 'GET'
  })
}
/**
 * 获取所有的业务类型
 * @param data
 *
 */
export const getBizType = () => {
  return request({
    url: env.ferryUrl + '/merchant/getBizType',
    method: 'GET'
  })
}

/**
 * 获取车辆信息分页
 * @param data
 *
 */
export const getCarPage = (data) => {
  return request({
    url: env.ferryUrl + '/car/page',
    method: 'POST',
    data
  })
}

/**
 * 获取车辆详情
 * @param data
 *
 */
export const getCarInfo = (carId) => {
  return request({
    url: env.ferryUrl + `/car/getCarInfo/${carId}`,
    method: 'GET'
  })
}

/**
 * 车辆或司机审核接口
 * @param data
 *
 */
export const driverAudit = (data) => {
  return request({
    url: env.ferryUrl + '/driver/audit',
    method: 'POST',
    data
  })
}

/**
 * 新增/编辑保险
 * @param data
 *
 */
export const insureSaveOrUpdate = (data) => {
  return request({
    url: env.ferryUrl + '/car/insure/saveOrUpdate',
    method: 'POST',
    data
  })
}

/**
 * 删除保险信息
 * @param data
 *
 */
export const insureDelete = (id) => {
  return request({
    url: env.ferryUrl + `/car/insure/delete/${id}`,
    method: 'DELETE'
  })
}

/**
 * 获取车辆品牌
 * @param data
 *
 */
export const getListAllCarBrandAPI = () => {
  return request({
    url: env.ferryUrl + '/car/getListAllCarBrand',
    method: 'GET'
  })
}

/**
 * 选择品牌下的车型
 * @param data
 *
 */
export const getListCarSeriesByBrandIdAPI = (id) => {
  return request({
    url: env.ferryUrl + `/car/getListCarSeriesByBrandId/${id}`,
    method: 'GET'
  })
}

/**
 * 获取车辆颜色
 * @param data
 *
 */
export const getListAllCarColorAPI = () => {
  return request({
    url: env.ferryUrl + '/car/getListAllCarColor',
    method: 'GET'
  })
}
/**
 * 新增/编辑车辆
 * @param data
 *
 */
export const saveOrUpdate = (data) => {
  return request({
    url: env.ferryUrl + '/car/v2/saveOrUpdate',
    method: 'POST',
    data
  })
}
/**
 * 删除车辆信息
 * @param data
 *
 */
export const carDelete = (id) => {
  return request({
    url: env.ferryUrl + `/car/delete/${id}`,
    method: 'DELETE'
  })
}
/**
 * 封禁或解禁车辆
 * @param data
 *
 */
export const bannedUnblock = (data) => {
  return request({
    url: env.ferryUrl + '/car/banned/unblock',
    method: 'POST',
    data
  })
}
/**
 * 监管报备
 * @param data
 *
 */
export const carReport = (data) => {
  return request({
    url: env.ferryUrl + '/car/report',
    method: 'POST',
    data
  })
}

/**
 * 获取地区树
 * @param data
 *
 */
export const getDriverAreaTree = (data) => {
  return request({
    url: env.ferryUrl + '/driver/area-tree',
    method: 'GET',
    data
  })
}

/**
 * 获取该司机已经绑定的车辆跟线路信息
 * @param driverId
 *
 */
export const notBindCarInfo = (merchantId) => {
  return request({
    url: env.ferryUrl + `/driver/notBind/carInfo/${merchantId}`,
    method: 'GET'
  })
}
/**
 * 获取供应商线路
 * @param driverId
 *
 */
export const queryAllLowLine = (id) => {
  return request({
    url: env.ferryUrl + `/lineAdmin/getLineByMerchantIds?merchantId=${id}`,
    method: 'GET'
  })
}
/**
 * 绑定车辆
 * @param driverId
 *
 */
export const driverBindCar = (data) => {
  return request({
    url: env.ferryUrl + '/driver/bindCar',
    method: 'POST',
    data
  })
}
